import { WORKFLOW_MODULE_ID } from './../../../../../../constants/workflow.constants';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { LOG_STEP_TABS, LogSubmitTabsComponent } from '../submit-tabs/submit-tabs.component';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { PAGES } from '../../log-details.component';
import { COMPLIANCE_CRITERIA, defaultUnitLabel } from 'constants/log-step.constants';
import { ComputedFrom } from '@certemy/common';
import { SignatureComponent } from 'components/signature/signature.component';
import { STEP_TYPES } from 'constants/status.constants';
import _get from 'lodash-es/get';

@Component({
  selector: 'cm-log-submit-content',
  templateUrl: './submit-content.component.html',
  styleUrls: ['./submit-content.component.scss'],
})
export class LogSubmitContentComponent {
  @Input() step;
  @Input() workflowTypeId: number;
  @Input() hideButtons: boolean;
  @Input() hideMultipleTab: boolean;
  @Input() showSignature: boolean;
  @Input() hideTitle: boolean;
  @Output() goToPage = new EventEmitter();
  @Output() submitForm = new EventEmitter();
  readonly PAGES = PAGES;
  readonly COMPLIANCE_CRITERIA = COMPLIANCE_CRITERIA;
  readonly WORKFLOW_MODULE_ID = WORKFLOW_MODULE_ID;
  activeSubmitTab = LOG_STEP_TABS.SINGLE;
  LOG_STEP_TABS = LOG_STEP_TABS;
  error: any;
  @ViewChild(LogSubmitTabsComponent) tabsComponent: LogSubmitTabsComponent;
  @ViewChild(SignatureComponent) signatureComponent: SignatureComponent;

  @ComputedFrom('step', 'activeSubmitTab')
  get saveAsDraftEnabled(): boolean {
    return this.step.content.allowMultipleEntries && this.activeSubmitTab !== LOG_STEP_TABS.MULTIPLE;
  }

  @ComputedFrom('step')
  get getUnitLabel(): string {
    return this.step.step_type_id === STEP_TYPES.LOG_NEW
      ? _get(this.step, 'content.unit_label') || defaultUnitLabel
      : 'hours';
  }

  @ComputedFrom('step')
  get getEntryLabel(): string {
    return this.step.step_type_id === STEP_TYPES.LOG_NEW ? 'entry' : 'entries';
  }

  onTabChange(event: NgbNavChangeEvent) {
    this.activeSubmitTab = event.nextId as LOG_STEP_TABS;
  }

  submit() {
    const formData = this.tabsComponent.getFormData();
    const form = this.tabsComponent.getForm().dynamicForm;
    this.error = this.showSignature && this.signatureComponent.getSignatureErrors();
    if (!formData || (!form.valid && this.activeSubmitTab === LOG_STEP_TABS.SINGLE)) {
      this.tabsComponent.getForm().checkFormForErrors();
      return;
    }
    if (!this.showSignature || !this.error) {
      this.submitForm.emit({ ...formData, saveAsDraft: false });
    }
  }

  saveAsDraft() {
    const formData = this.tabsComponent.getFormData();
    this.submitForm.emit({ ...formData, saveAsDraft: true });
  }

  reset() {
    this.tabsComponent.getForm().restoreChanges();
  }
}
